import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { ErrorBannerContext } from 'ErrorBanner';
import { TranslationConsumer } from 'giro-react-toolkit/source/Translation';

import './GeoLocation.scss';

/**
 * Component used to fetch the current geolocation of the user using the browser's capabilities.
 */
class GeoLocation extends Component {
   constructor(props) {
      super(props);
   }

   /**
    * Handle the click on the button to get the position of the user.
    */
   handleClick () {
      const enableHighAccuracy = this.props.enableHighAccuracy;
      const timeout = this.props.timeout;
      const maximumAge = this.props.maximumAge;
      const onSuccess = this.props.onSuccess;

      return (window.navigator.geolocation.getCurrentPosition(
                             // success
         position => {
            onSuccess(position);
         },
                             // error
         error => {
            this.context.displayErrorMessage(this.errorMessage(error));
         },
                             // PositionOptions
         { enableHighAccuracy, timeout, maximumAge }
      ));
   }

   /**
    * get Error message to display from error code
    * @param positionError - Object containing a code and a message.
    */
   errorMessage(positionError) {
      if (positionError.code === 1) { // PERMISSION_DENIED
         return ('ReachMapRes.GeoLocationErrorPermissionDeniedText');
      } else if (positionError.code === 3) { // TIMEOUT
         return ('ReachMapRes.GeoLocationErrorTimeoutText');
      } else { // also code 2 POSITION_UNAVAILABLE
         return ('ReachMapRes.GeoLocationErrorPosUnavailableText');
      }
   }

   /**
    * Renders the GeoLocation component
    */
   render () {
                             // GeoLocation is not available
      if (!('geolocation' in window.navigator)) {
         return;
      }

      let classNames = ClassNames(
         "geo-location",
         this.props.className
      );
      return (
         <TranslationConsumer>
            {({ localizeValue }) => (
               <button
                  className={ classNames }
                  onClick={ () => this.handleClick() }
                  aria-label={ localizeValue('ReachMapRes.GeoLocationButtonLabel') }>
               </button>)}
         </TranslationConsumer>
      );
   }
}

GeoLocation.contextType = ErrorBannerContext;

GeoLocation.propTypes = {
   /**
    * Indicates if the device returns the best possible result for the position.
    * Might be slower and consume more battery.
    */
   enableHighAccuracy: PropTypes.bool,
   /**
    * The maximum age of a cached position in milliseconds. If 0, the position is not cached.
    */
   maximumAge: PropTypes.number,
   /**
    * The timeout in milliseconds the device is allowed to take in order to return a position.
    */
   timeout: PropTypes.number,
   /**
    * A callback when the location is successfully fetched
    */
   onSuccess: PropTypes.func,
   /**
    * The class names to add to the geolocation button
    */
   className: PropTypes.string
}

GeoLocation.defaultProps = {
   enableHighAccuracy: true,
   timeout: 3000, /* 3s */
   maximumAge: 0  /* no caching */
}

export default GeoLocation;
